/* eslint react/jsx-no-target-blank: 0 */
import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import Share from "../icons/share"
import classNames from "classnames"
import { Link } from "gatsby"
import loadable from '@loadable/component'

import {
  addCommas,
  formatJPNumberUnit,
} from "../../utils/str"

const ManagementIndexGraph = loadable(() => import('./management-index-graph'))
const styles = theme => ({
  root: {
    padding: "30px 30px 20px 30px",
    boxSizing: "border-box",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      padding: "20px 20px 30px 20px",
    },
  },

  corpLogo: {
    height: "60px",
    width: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "11px",
    marginRight: "20px",
    [theme.breakpoints.down("xs")]: {
      margin: "0 auto 10px auto",
    },
  },

  logoImg: {
    width: "100%",
    height: "auto",
    minWidth: "60px",
    maxWidth: "60px",
  },

  hpLink: {
    display: "inline-flex",
    alignItems: "flex-end",
  },

  firstRow: {
    borderTop: "1px solid #D8DBDF",
  },

  row: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "row",
    width: "100%",
    fontSize: "13px",
    borderBottom: "1px solid #D8DBDF",
    boxSizing: "border-box",
    padding: "18px 10px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      padding: "7px 10px 18px 10px",
    },
  },

  label: {
    width: "25%",
    color: "#000000",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      paddingTop: "10px",
    },
  },

  value: {
    flex: 3,
    color: "#000000",
    whiteSpace: "pre-wrap",
    [theme.breakpoints.down("xs")]: {
      paddingTop: "10px",
      letterSpacing: "0.13px",
      textIndent: "0.13px",
    },
  },

  inline: {
    paddingBottom: "20px",
    display: "inline-flex",
    alignItems: "flex-start",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      display: "block",
    },
  },

  company: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "center",
    },
  },

  companyName: {
    fontSize: "18px",
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      fontSize: "20px",
      textAlign: "center",
    },
  },

  buttonContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: "10px",
  },

  button: {
    color: "#71737B",
    fontSize: "11px",
    minWidth: "unset",
    minHeight: "unset",
    padding: "5px 10px",
    marginRight: "-10px",
    textDecoration: "none",
    "&:hover": {
      background: "none",
      textDecoration: "underline",
    },
  },

  industryContainer: {
    display: "inline-flex",
    alignItems: "center",
    width: "100%",
    marginBottom: "12px",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
      marginBottom: "5px",
    },
  },

  industryItem: {
    fontSize: "12px",
  },

  financialStatementsItem: {
    display: "inline-flex",
    width: "100%",
  },

  financialStatementsItemUl: {
    paddingLeft: "15px",
    margin: "0",
  },

  financialStatementsItemLink: {
    display: "inline-flex",
    alignItems: "flex-center",
    color: "#1866FF",
    "&:visited": {
      color: " #13367B",
    }
  },

  link: {
    color: "#1866FF",
    "&:visited": {
      color: " #13367B",
    }
  },

  relevantLink: {
    textDecoration: "underline",
    fontSize: "11px",
    marginRight: '5px',
    color: "#1866FF",
    "&:visited": {
      color: " #13367B",
    },
    [theme.breakpoints.down("xs")]: {
      paddingTop: "10px",
    },
  },

  renderLink: {
    color: "#1866FF",
    "&:visited": {
      color: " #13367B",
    },
    [theme.breakpoints.down("xs")]: {
      paddingTop: "10px",
    },
  },

  rankContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    padding: "0px 12px",
    boxSizing: "border-box",
  },

  rankItem: {
    fontSize: "13px",
    marginBottom: "12px",
  },

  rankTitle: {
    marginRight: "20px",
  },

  rankNo: {
    fontSize: "20px",
    fontWeight: "bold",
    marginRight: "5px",
  },

  rankDesc: {
    fontSize: "11px",
    color: "#71737B",
  },

  en_name: {
    fontSize: "12px",
    marginTop: "5px",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
    },
  },

  furigana: {
    fontSize: "11px",
    color: "#71737B",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
    },
  },

  corpInfo: {
    display: "flex",
    marginRight: "20px",
    [theme.breakpoints.down("xs")]: {
      display: "block",
      width: "100%",
      marginRight: "0",
    },
  },

  desc: {
    [theme.breakpoints.down("xs")]: {
      paddingTop: "10px",
    },
  },

  lpButton: {
    color: "#1866FF",
    padding: "11px 12px",
    background: "#EFF7FF",
    borderRadius: "3px",
    margin: "auto 0 auto auto",
    fontSize: "9px",
    [theme.breakpoints.down("xs")]: {
      margin: "15px 0 20px auto",
      textAlign: "center",
      fontSize: "11px",
      padding: "8px",
    },
  },

  pc: {
    display: "block",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },

  sp: {
    display: "none",
    [theme.breakpoints.down("xs")]: {
      display: "block",
    },
  },
})

class CorporationProfile extends React.Component {
  state = {
    jsic_l: "",
    jsic_s: "",
    date_of_establishment: "",
  }

  componentDidMount() {
    const { item } = this.props

    if (item && !!item.corporation_detail_detail) {
      const detail = JSON.parse(item.corporation_detail_detail)
      let jsic_l = "",
        jsic_s = "",
        date_of_establishment = ""

      if (detail.hasOwnProperty("jsic_l")) {
        jsic_l = detail["jsic_l"]
      }

      if (detail.hasOwnProperty("設立日")) {
        date_of_establishment = detail["設立日"]
      }

      if (detail.hasOwnProperty("jsic_s")) {
        jsic_s = detail["jsic_s"]
        this.props.getRankJsicSById(jsic_s)
      }

      this.setState({
        jsic_l: jsic_l,
        jsic_s: jsic_s,
        date_of_establishment: date_of_establishment,
      })
    }
  }

  renderRow = (renderItem, index) => {
    const { classes, item } = this.props
    let linkText = `${renderItem.title}の近い企業`
    if (renderItem.title === '上場市場' && (item.listing_type === '未上場' || item.listing_type === '上場廃止')) {
      linkText = '他の未上場の企業'
    } else if (renderItem.title === '上場市場' && item.listing_type) {
      linkText = `他の${item.listing_type}上場の企業`
    } else if (renderItem.title === '決算月' && item.clothing_month) {
      linkText = `決算月の同じ企業`
    }
    if (renderItem.value && renderItem.value !== "-") {
      return (
        <div className={classNames(
            classes.row,
            index === 0 ? classes.firstRow : ""
          )} key={index}>
          <div className={classes.label}>{renderItem.title}</div>
          {/* 証券コードの場合はyahooファイナンスへのリンクを設定 */}
          {renderItem.title === '証券コード' ? (
            <a
              className={classes.renderLink}
              href={`https://finance.yahoo.co.jp/quote/${renderItem.value}.T`}
              target="_blank"
              rel="noopener"
              style={{ textDecoration: "underline" }}
            >
              {renderItem.value}
            </a>
          ) : (
            <div className={classes.value}>{renderItem.value}</div>
          )}
          {renderItem.to &&  (
            <Link className={classes.relevantLink} to={renderItem.to}>{linkText}</Link>
          )}
          {renderItem.title === '法人番号' && (
            this.renderReferenceLink('corporate_number')
          )}
        </div>
      )
    }
  }

  renderIndustry = () => {
    const { classes } = this.props
    const { jsic_l, jsic_s } = this.state

    if (!!jsic_l && !!jsic_s) {
      return (
        <div className={classes.industryContainer}>
          <Link className={classes.link} to={`/industries/${jsic_l}`} style={{ textDecoration: "underline" }}>
            <span className={classes.industryItem}>{jsic_l}</span>
          </Link>
          <span className={classes.industryItem} style={{ marginRight: "5px" }}>,</span>
          <span className={classes.industryItem}>{jsic_s}</span>
        </div>
      )
    } else if (!!jsic_l) {
      return (
        <div className={classes.industryContainer}>
          <Link className={classes.link} to={`/industries/${jsic_l}`} style={{ textDecoration: "underline" }}>
            <span className={classes.industryItem}>{jsic_l}</span>
          </Link>
        </div>
      )
    }
  }

  renderFinancialStatements = () => {
    const { classes, item } = this.props
    let financialStatements = item.financial_statements
    if (financialStatements) {
      // 文字列でJSONが入っているためJSONに明示的に変換
      financialStatements = JSON.parse(financialStatements)
    }

    if (financialStatements && financialStatements.length > 0) {
      return (
        <ul className={classes.financialStatementsItemUl}>
          {financialStatements.map((e, i) => (
            <li key={i} style={{ marginBottom: (i === financialStatements.length - 1) ? "" : "10px" }}>
              <div className={classes.financialStatementsItem}>
                {(() => {
                  if (e.url) {
                    return (<a
                        className={classes.financialStatementsItemLink}
                        href={e.url}
                        target="_blank"
                        rel="noopener"
                        >
                          <span>{e.title}</span>
                          <Share
                            width={18}
                            height={18}
                            color="#71737B"
                            style={{ marginLeft: "5px" }}
                          />
                        </a>
                      )
                  } else {
                    return (
                      <span>{e.title}</span>
                    )
                  }
                })()}
              </div>
            </li>
          ))}
        </ul>
      )
    }
  }

  // 参照元のリンクを表示する
  renderReferenceLink = (type) => {
    const { classes, source_url, corporationName, item } = this.props
    let source_name, url

    if (type === 'source_url' && source_url) {
      source_name =
        source_url.indexOf('info.gbiz.go.jp') !== -1 ? 'gBizInfo' :
        source_url.indexOf('disclosure.edinet-fsa') !== -1 ? 'EDINET' :
        `${corporationName}の企業情報`
      url = source_url
    } else if (type === 'corporate_number') {
      source_name = '国税庁法人番号公表サイト'
      url = `https://www.houjin-bangou.nta.go.jp/henkorireki-johoto.html?selHouzinNo=${item.corporate_number}`
    }

    if (source_name && url) {
      return (
        <span style={{ fontSize: "11px", paddingTop: source_name === '国税庁法人番号公表サイト' ? '10px' : 0}}>
          参照：
          <a
            className={classes.link}
            href={url}
            target="_blank"
            rel="noopener"
            style={{ textDecoration: "underline" }}
          >
            {source_name}
          </a>
        </span>
      )
    }

    return null
  }

  render() {
    const { classes, item, corporationId } = this.props

    let changeCause = item.change_cause
    let financialStatements = item.financial_statements
    if (changeCause) {
      // 末尾以外「合併し」「合併して」以外の「合併」の後に改行を追加
      changeCause = changeCause.replace(/合併(?=.)(?!し)/g, `合併\n`)
      // 日付と文字列の間にスペースを追加
      changeCause = changeCause.replace( /(\D+)年(\D+)月(\D+)日/g , "$1年$2月$3日 " );
    }
    if (financialStatements) {
      // 文字列でJSONが入っているためJSONに明示的に変換
      financialStatements = JSON.parse(financialStatements)
    }

    let numberOfEmployees = item.number_of_employees
    if (
      numberOfEmployees === 0 ||
      numberOfEmployees === "0" ||
      numberOfEmployees === "-" ||
      numberOfEmployees === ""
    ) {
      numberOfEmployees = null
    } else {
      numberOfEmployees = addCommas(numberOfEmployees) + "人"
    }

    let clothingMonth = item.clothing_month
    if (
      clothingMonth === 0 ||
      clothingMonth === "0" ||
      clothingMonth === "-" ||
      clothingMonth === ""
    ) {
      clothingMonth = null
    } else {
      clothingMonth = clothingMonth + "月"
    }

    const basicInfo = [
      {
        title: "本社・本店",
        value: item.prefecture_name + item.city_name + item.street_number,
        to: `/corporations/${corporationId}/relevant_main_office`
      },
      {
        title: "主要事業所",
        value:
          item.shikiho_main_office &&
          item.shikiho_main_office
            .split("\n")
            .map((line, i) => <div key={i}>{line}</div>),
      },
      { title: "電話番号", value: item.shikiho_tel },
      { title: "連結事業", value: item.shikiho_consolidated_business },
      { title: "従業員数", value: numberOfEmployees, to: `/corporations/${corporationId}/relevant_number_of_employees` },
      { title: "設立日", value: this.state.date_of_establishment, to: `/corporations/${corporationId}/relevant_establishment_year` },
      {
        title: "資本金",
        value: item.capital_stock
          ? formatJPNumberUnit(item.capital_stock)
          : null,
        to: `/corporations/${corporationId}/relevant_capital_stock`
      },
      {
        title: "売上高",
        value: item.amount_of_sales
          ? formatJPNumberUnit(item.amount_of_sales)
          : null,
        to: `/corporations/${corporationId}/relevant_amount_of_sales`
      },
      { title: "上場市場", value: item.listing_type, to: `/corporations/${corporationId}/relevant_listing_type` },
      { title: "決算月", value: clothingMonth, to: `/corporations/${corporationId}/relevant_clothing_month` },
      { title: "平均年齢", value: item.average_age, to: `/corporations/${corporationId}/relevant_average_age` },
      { title: "平均年収", value: item.annual_income, to: `/corporations/${corporationId}/relevant_annual_income` },
      { title: "法人番号", value: item.corporate_number },
      // SEOでインデックスへの影響がありそうなためコメント
      //{ title: "特許取得数", value: item.patented ? `${item.patented}件` : null },
      //{ title: "意匠登録数", value: item.registered_design ? `${item.registered_design}件` : null },
      //{ title: "商標登録数", value: item.registered_trademark ? `${item.registered_trademark}件` : null },
      { title: "法人情報最終更新", value: changeCause },
      { title: "証券コード", value: item.shikiho_stock_code },
    ];

    if (financialStatements && financialStatements.length > 0) {
      basicInfo.push(
        { title: "決算報告書", value: this.renderFinancialStatements() }
      );
    }

    const logoPath = item.logo_path ? item.logo_path : "https://d1fb6fvpaeq04z.cloudfront.net/no-image/no-image.png"
    const logoFileName = logoPath.split('.').slice(0, -1).join('.')

    return (
      <div className={classes.root}>
        <div className={classes.inline}>
          <div className={classes.corpInfo}>
            <div className={classes.corpLogo}>
              <picture>
                <source
                  className={classes.logoImg}
                  width={60}
                  height={60}
                  srcSet={logoFileName + '.webp'}
                  type="image/webp"
                />
                <img
                  src={logoPath}
                  alt="logo"
                  className={classes.logoImg}
                  width={60}
                  height={60}
                />
              </picture>
            </div>
            <div>
              {this.renderIndustry()}
              <div className={classes.furigana}>{item.corporation_furigana ? item.corporation_furigana : ''}</div>
              <div className={classes.en_name}>{item.corporation_en_name ? item.corporation_en_name : ''}</div>
              <div className={classes.company}>
                <h3 className={classes.companyName}>{item.company_name ? item.company_name : item.name}</h3>
                {item.shikiho_site_url && (
                  <a
                    className={classes.hpLink}
                    style={{ width: "unset" }}
                    href={item.shikiho_site_url}
                    target="_blank"
                    rel="noopener"
                  >
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#71737B",
                        marginLeft: "5px",
                      }}
                    >
                      会社HP
                    </span>
                    　
                    <Share
                      width={18}
                      height={18}
                      color="#71737B"
                      style={{ marginLeft: "-15px" }}
                    />
                  </a>
                )}
              </div>
            </div>
          </div>
          <a
            className={classNames(classes.lpButton, classes.pc)}
            href="https://keymanletter.com/register-account/"
            rel="noopener"
            target="_blank"
          >
            登録して、この会社の決裁者の更新情報を受け取る
          </a>
        </div>

        <p style={{ fontSize: "12px", marginBottom: "20px" }}>
            {item.shikiho_feature}
        </p>

        <a
          className={classNames(classes.lpButton, classes.sp)}
          href="https://keymanletter.com/register-account/"
          rel="noopener"
          target="_blank"
        >
          登録して、この会社の決裁者の更新情報を受け取る
        </a>

        {item.shikiho_performances && (
          <div style={{ paddingBottom: "30px", height: "350px"}}>
            <ManagementIndexGraph
              items={JSON.parse(item.shikiho_performances)}
            />
          </div>
        )}
        {basicInfo.map((info, i) => this.renderRow(info, i))}
        <div style={{ textAlign: 'end', marginTop: '20px', fontSize: '11px' }}>
          {this.renderReferenceLink('source_url')}
        </div>
      </div>
    )
  }
}

CorporationProfile.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
  corporationId: PropTypes.number,
  jsicSRankStats: PropTypes.object,
  getRankJsicSById: PropTypes.func.isRequired,
}

export default withStyles(styles)(CorporationProfile)
